<template>
  <div class="warp"> 
    <BaseHeader />
    <main>
        <div class="card">
          <div class="card-head">
              <div class="circle-authen">
                  <img src="/images/encrypted.png">
              </div> 
              <h1 class="text-center d-block d-md-none">ยืนยันตัวตน / AUTHENTICATION</h1>
          </div>
          <div class="card-body">
          <label for="birthdate" class="d-block">
              วันเกิดของผู้ป่วย / Patient Date of Birth
          </label>
          <div class="InputBirthdate">
              <input type="password" name="birthdate" id="birthdate" v-model="password" @keyup="alert_message = ''">
              <a onclick="ChangeTypeFunction()"><img src="/images/eye-close-up.png" ></a>
          </div>
            <div class="font-weight-bold text-red">{{ alert_message }}</div>
            <label class="checkbox-container">ยอมรับเงื่อนไขการใช้งาน / Accept the terms of use <br><a href="https://wpg.addressasia.com/BDMS_Payment_Terms.pdf">เงื่อนไขการใช้งาน / Terms of use</a>
                <input type="checkbox" checked="checked" v-model="terms">
                <span class="checkmark"></span>
            </label>
      </div>
      <button @click="onValidate" :disabled="!formValid" :class="{ deactive: !formValid}">
          <span class="d-block d-md-none" >ยืนยัน / CONFIRM</span>
      </button><br>
      </div> 
        <div class="under-card-text mb-5">
            * กรุณาระบุรหัสผ่าน ตัวอย่างเช่น ผู้ป่วยเกิดวันที่  1 กุมภาพันธ์ พ.ศ.2514 รหัสคือ 01022514
            <br><br class="d-md-none d-block">* Please enter password in ddmmyyyy format. For example, February 1,1971 is 01021971.
        </div>
    </main>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        validate: false,
        error: false,
        loading: false,
        password: '',
        terms: false,
        alert_message: ''
      }
    },
  
    created() { 
    },  
    computed: {
    text() {
      let obj = {}
      if (this.$store.state.language == 'TH') {
        obj = {
          authen: 'ยืนยันตัวตน',
          birthday: 'วันเกิดของผู้ป่วย',
          term: 'ยอมรับเงื่อนไขการใช้งาน/',
        }
      }else{
        obj = {
          authen: 'AUTHENTICATION',
          birthday: 'Patient Date of Birth',
          term: 'Accept the terms of use',
        }
      }
    },
      formValid() {
        let res = true
  
        if (this.password.length < 8) {
          res = false
        }
  
        if (!this.terms) {
          res = false
        }
  
        return res
      },
  
      formattedBirthdate() {
        const split = this.$store.state.billData.ref2.split('-')
        const year_1 = split[2] + split[1] + split[0]
        const year_2 = split[2] + split[1] + (parseInt(split[0]) + 543)
        return [year_1, year_2]
      },
  
      billData() {
        return this.$store.state.billData
      },
      checkRedirectUrl() {
          let res = false
          if (
            this.$store.state.backUrl != null &&
            this.$store.state.backUrl != ''
          ) {
            res = true
          } else {
            res = false
          }
          return res
        }
    },
  
    watch: {
      billData(newValue) {
        if (newValue) {
          if (this.$store.state.ref2) {
            sessionStorage.clear()
          } else {
            let page = '/'
            sessionStorage.setItem('linkcode', this.$route.query.linkcode)
            if (
              this.$store.state.billData.status &&
              this.$store.state.billData.status > 3 && 
              this.$store.state.billData.total == this.$store.state.billData.paid 
            ) {
              if (this.checkRedirectUrl) {
                  window.location = this.$store.state.backUrl
                }
              page = '/billRecieve'
            } else {
              page = '/paymentMethods'
            }
            this.$router.push(page + `/?linkcode=${this.$route.query.linkcode}`)
          }
        }
      }
    },
  
    methods: {
      onValidate() { 
        if (this.password.length == 8) {
          this.loading = true
          this.error = false
          if (
            this.password === this.formattedBirthdate[0] ||
            this.password === this.formattedBirthdate[1]
          ) {
            this.$store.dispatch('getBillDataValidated', this.$route.query.linkcode)
            this.onComplete()
          } else {
            this.loading = false
            this.error = true
            this.alert_message = 'รหัสผ่านที่ได้รับ (Password) หรือวันเกิด (Date of birth)'
          }
        } else {
          this.error = true
          this.alert_message = 'รหัสผ่านที่ได้รับ (Password) หรือวันเกิด (Date of birth)'
        }
      },
      onComplete() {
        sessionStorage.setItem('linkcode', this.$route.query.linkcode)
        localStorage.linkcode = this.$route.query.linkcode;
        if (this.$store.state.billData.status > 3) {
          if (this.checkRedirectUrl) { 
            window.location = this.$store.state.backUrl
          } else {
            this.$router.push(
              `/billRecieve/?linkcode=${this.$route.query.linkcode}`
            )
          }
        } else {
          this.$router.push(
            `/paymentMethods/?linkcode=${this.$route.query.linkcode}`
          )
        }
      }  
    }
  }
  </script>
  
<style scoped>  

h1{
    font-weight: 600;
    color: #002D72;
    margin: 0;
}
  
.font-weight-bold{ 
  padding-left: 15px;
  margin-bottom: 22px;
}

label{
    font-weight: 400;
    font-size: 28px;
    margin-bottom: 15px;
}
.card{
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    height: auto;
    background-color: white;
    margin-top: 37px;
    margin-bottom: 28px;
    border-radius: 20px;
    box-shadow: 0px 6px 16px 4px rgba(130, 195, 237, 0.15);

    border:unset !important;
    background-color: #fff;
    margin-top:0px;
}

.card-head{
    background-color: #EAEDFD;
    height: 199px;
    padding-top: 38px;

    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}
 
.circle-authen{
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 14px;
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background-color: white;
    position: relative;
}

.circle-authen img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}

.card-body{
    padding: 30px 15% 0 15%;
}

.InputBirthdate{
    padding: 15px;
    /* margin-bottom: 22px; */
    height: 70px;
    border-radius: 60px;
    background-color: #F8F8F8;
    border: 1px solid rgba(248, 248, 248, 0.8);
}

.InputBirthdate img{
  float: right;
  margin-right: 15px;
}

input#birthdate{
    width: 80%;
    margin-left: 10px;
    background: none;
    border: none;
    border-radius: 5px;
    font-size: 20px;
}

input#birthdate:focus{
    outline: none;
}

/*For checkbox https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox*/
  /* The container */
  .checkbox-container {
    display: block;
    position: relative;
    padding-left: 50px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-weight: 400;
    font-size: 20px;
    color: #002D72;
  }
  .checkbox-container a{
    text-decoration: underline !important;
    color: #002D72;
  }
  
  /* Hide the browser's default checkbox */
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 30px;
    width: 30px;
    background-color: #eee;
    border-radius: 5px;
  }
  
  /* On mouse-over, add a grey background color */
  .checkbox-container:hover input ~ .checkmark {
    background-color: #ccc;
  }
  
  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkmark {
    background-color: #002D72 !important;
  }
  
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  /* Show the checkmark when checked */
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  /* Style the checkmark/indicator */
  .checkbox-container .checkmark:after {
    left: 50%;
    top: 50%;
    width: 8px;
    height: 15px;
    border: solid white;
    border-width: 0 4px 4px 0;
    -webkit-transform: rotate(45deg) translate(-110%,-25%);
    -ms-transform: rotate(45deg) translate(-110%,-25%);
    transform: rotate(45deg) translate(-110%,-25%);
  }


  .under-card-text{
    display: block;
    margin: auto;
    width: fit-content;
    font-weight: 400;
    font-size: 20px;
    color: #002D72;
  }

  .text-red{
    color: #AB2328;
  }
  
  button{
    display: block;
    margin: 40px auto 40px auto;
    width: 40%;
    height: 70px;
    border-radius: 50px;
    border:none;
    background-color: #002D72;
    color: white;
    font-family: 'Kanit';
    font-weight: 400;
    font-size: 30px; 
  }
@media only screen and (max-width: 1200px){
}
@media only screen and (max-width: 992px) {
  .card {
    width: 100%;
  }
}

@media only screen and (max-width: 768px) {
}

@media only screen and (max-width: 576px) {
    .card button{
        font-size: 24px;
        width: 65%;
    }
    button#submit-payment{
        margin: 30px auto;
    }
  .InputBirthdate img{
    float: right;
    margin-right: 15px;;
    margin-top: unset;
  }
}
@media only screen and (max-width: 511px) {
  .InputBirthdate img{
    margin-top: -29px;
  }
}
@media only screen and (max-width: 414px) {
  .InputBirthdate img{
    margin-top: unset;
  }
  .card{
        width: 90% !important;
        margin-top: 15px !important;
    } 
    .card button{
        font-size: 24px;
        width: 65%;
    }
    input#birthdate{
        width: 65% !important; 
    }  
    label{
        font-size: 22px;
    }
} 
@media only screen and (max-width: 378px) {
  .InputBirthdate img{
    margin-top: unset;
  }
}  
</style>

 